var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeSlide6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 223.14 160",
    s6yle: "enable-background:new 0 0 223.14 160;",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.s60{fill:#F2F2F2;}\r\n\t.s61{fill:#FFFFFF;}\r\n\t.s62{fill:#E7E6E6;}\r\n\t.s63{fill:#302F42;}\r\n\t.s64{fill:#F6B7BA;}\r\n\t.s65{fill:#616BB0;}\r\n\t.s66{fill:#9F626B;}\r\n\t.s67{fill:#F6B5B7;}\r\n\t.s68{fill:#403E56;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s60",
    d: "M36.52,121.88H185.5v-8.98c0-1.88-2.26-3.72-6.2-5.07l-0.04-0.01c-2.66-0.94-19.67-7.62-28.87-7.42 c-4.86,0.11-9.02,0.93-12.37,2.45c-10.42,4.73-24.1,6.47-31.32,5.1c-6.37-1.21-23.86-3.21-30.32-3.12 c-9.05,0.12-9.08,1.64-18.37,6.52c-3.55,1.86-4.87,2.1-21.49,3.58V121.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s60",
    d: "M12.5,108.68c-0.32-4.82,1.72-9.69,5.96-11.47c-0.86,4.96,0.2,10.48,2.92,15.26c1.06,1.86,2.42,3.85,2.13,5.8 c-0.18,1.21-1,2.17-2.01,2.8c-1.01,0.63-2.19,0.96-3.36,1.29l-0.2,0.21C15.15,118.25,12.83,113.5,12.5,108.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s61",
    d: "M18.52,97.29c-2.1,3.24-3.04,7.09-2.65,10.93c0.06,0.88,0.26,1.74,0.58,2.56c0.35,0.82,0.89,1.55,1.58,2.12 c0.63,0.55,1.34,1.05,1.84,1.73c0.51,0.67,0.72,1.51,0.59,2.34c-0.15,0.97-0.65,1.78-1.17,2.55c-0.58,0.86-1.2,1.73-1.3,2.84 c-0.01,0.13-0.23,0.08-0.21-0.06c0.18-1.92,1.8-3.08,2.34-4.83c0.3-0.85,0.19-1.8-0.29-2.56c-0.47-0.72-1.2-1.23-1.84-1.79 c-0.68-0.55-1.23-1.24-1.61-2.02c-0.36-0.8-0.59-1.66-0.68-2.54c-0.22-1.89-0.13-3.81,0.27-5.67c0.42-2.05,1.23-4,2.39-5.75 C18.42,97.03,18.59,97.19,18.52,97.29L18.52,97.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s61",
    d: "M15.69,106.93c-1.43-0.28-2.52-1.43-2.73-2.88c-0.02-0.14,0.2-0.14,0.21,0c0.19,1.34,1.21,2.42,2.54,2.67 c0.06,0.01,0.1,0.06,0.09,0.12C15.8,106.9,15.75,106.94,15.69,106.93C15.69,106.93,15.69,106.93,15.69,106.93L15.69,106.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s61",
    d: "M17.68,112.66c1.05-0.78,1.72-1.98,1.83-3.29c0.01-0.13,0.23-0.08,0.21,0.06c-0.12,1.36-0.82,2.6-1.91,3.42 C17.71,112.92,17.58,112.73,17.68,112.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s61",
    d: "M16.64,100.99c0.49,0.21,1.06,0.15,1.5-0.15c0.1-0.08,0.23,0.11,0.13,0.19c-0.49,0.34-1.12,0.4-1.66,0.17 c-0.06-0.02-0.1-0.07-0.09-0.13c0.01-0.05,0.05-0.09,0.11-0.08C16.63,100.99,16.63,100.99,16.64,100.99L16.64,100.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s60",
    d: "M33.92,105.05c-0.06,0.05-0.12,0.1-0.19,0.15c-0.83,0.68-1.6,1.44-2.29,2.26c-0.05,0.06-0.11,0.13-0.16,0.19 c-1.66,2.03-2.87,4.38-3.56,6.91c-0.28,1.03-0.48,2.08-0.59,3.14c-0.16,1.48-0.21,3.12-0.84,4.35c-0.06,0.13-0.14,0.25-0.22,0.37 l-7.81,0.4c-0.02-0.01-0.04-0.01-0.06-0.02l-0.31,0.03c0-0.06,0.01-0.11,0.01-0.17c0-0.03,0-0.07,0-0.1c0-0.02,0-0.04,0-0.06 c0-0.01,0-0.01,0-0.02c0-0.02,0-0.04,0-0.06c0.02-0.33,0.04-0.65,0.06-0.98c0,0,0,0,0,0c0.13-2.45,0.58-4.87,1.32-7.2 c0.02-0.07,0.05-0.14,0.07-0.21c0.35-1.01,0.79-1.99,1.31-2.92c0.29-0.5,0.6-0.99,0.95-1.46c0.89-1.21,1.99-2.24,3.25-3.05 c2.59-1.73,5.79-2.31,8.82-1.61C33.76,105.01,33.84,105.03,33.92,105.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s61",
    d: "M33.93,105.15c-3.66,0.92-6.88,3.12-9.05,6.21c-0.48,0.66-0.84,1.39-1.06,2.18c-0.19,0.81-0.16,1.66,0.09,2.46 c0.22,0.77,0.53,1.55,0.57,2.34c0.04,0.78-0.31,1.53-0.92,2.02c-0.73,0.6-1.67,0.88-2.6,1.12c-1.04,0.26-2.12,0.52-2.89,1.24 c-0.09,0.09-0.25-0.08-0.15-0.17c1.34-1.26,3.48-1.12,5.03-2.04c0.72-0.43,1.29-1.1,1.32-2.01c0.02-0.8-0.3-1.6-0.53-2.38 c-0.26-0.78-0.32-1.61-0.18-2.41c0.18-0.79,0.5-1.55,0.96-2.22c0.99-1.51,2.25-2.83,3.72-3.89c1.69-1.24,3.61-2.14,5.64-2.66 C34,104.91,34.05,105.12,33.93,105.15L33.93,105.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s61",
    d: "M25.5,110.33c-1.09-1.03-1.36-2.61-0.64-3.69c0.07-0.11,0.26,0.02,0.19,0.13c-0.67,1.02-0.41,2.48,0.6,3.44 C25.76,110.3,25.6,110.43,25.5,110.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s61",
    d: "M23.74,115.61c1.33,0.1,2.65-0.35,3.64-1.24c0.09-0.09,0.25,0.08,0.15,0.17c-1.03,0.93-2.4,1.39-3.79,1.29 C23.61,115.82,23.61,115.61,23.74,115.61L23.74,115.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s61",
    d: "M29.98,106.66c0.33,0.46,0.85,0.75,1.42,0.79c0.14,0.01,0.14,0.22,0,0.21c-0.63-0.05-1.2-0.37-1.58-0.88 c-0.04-0.04-0.04-0.11,0-0.15C29.88,106.61,29.95,106.62,29.98,106.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s60",
    d: "M208.16,108.68c0.32-4.82-1.72-9.69-5.96-11.47c0.86,4.96-0.2,10.48-2.92,15.26c-1.06,1.86-2.42,3.85-2.13,5.8 c0.18,1.21,1,2.17,2.01,2.8c1.01,0.63,2.19,0.96,3.36,1.29l0.2,0.21C205.51,118.25,207.83,113.5,208.16,108.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s61",
    d: "M202.14,97.29c2.1,3.24,3.04,7.09,2.65,10.93c-0.06,0.88-0.26,1.74-0.58,2.56c-0.35,0.82-0.89,1.55-1.58,2.12 c-0.63,0.55-1.34,1.05-1.84,1.73c-0.51,0.67-0.72,1.51-0.59,2.34c0.15,0.97,0.65,1.78,1.17,2.55c0.58,0.86,1.2,1.73,1.3,2.84 c0.01,0.13,0.23,0.08,0.21-0.06c-0.18-1.92-1.8-3.08-2.34-4.83c-0.3-0.85-0.19-1.8,0.29-2.56c0.47-0.72,1.2-1.23,1.84-1.79 c0.68-0.55,1.23-1.24,1.61-2.02c0.36-0.8,0.59-1.66,0.68-2.54c0.22-1.89,0.13-3.81-0.27-5.67c-0.42-2.05-1.23-4-2.39-5.75 C202.23,97.03,202.07,97.19,202.14,97.29L202.14,97.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s61",
    d: "M204.97,106.93c1.43-0.28,2.52-1.43,2.73-2.88c0.02-0.14-0.2-0.14-0.21,0c-0.19,1.34-1.21,2.42-2.54,2.67 c-0.06,0.01-0.1,0.06-0.09,0.12C204.86,106.9,204.91,106.94,204.97,106.93C204.97,106.93,204.97,106.93,204.97,106.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s61",
    d: "M202.98,112.66c-1.05-0.78-1.72-1.98-1.83-3.29c-0.01-0.13-0.23-0.08-0.21,0.06c0.12,1.36,0.82,2.6,1.91,3.42 C202.95,112.92,203.08,112.73,202.98,112.66L202.98,112.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s61",
    d: "M204.02,100.99c-0.49,0.21-1.06,0.15-1.5-0.15c-0.1-0.08-0.23,0.11-0.13,0.19c0.49,0.34,1.12,0.4,1.66,0.17 c0.06-0.02,0.1-0.07,0.09-0.13c-0.01-0.05-0.05-0.09-0.11-0.08C204.03,100.99,204.03,100.99,204.02,100.99L204.02,100.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s60",
    d: "M186.73,105.05c0.06,0.05,0.12,0.1,0.19,0.15c0.83,0.68,1.6,1.44,2.29,2.26c0.05,0.06,0.11,0.13,0.16,0.19 c1.66,2.03,2.87,4.38,3.56,6.91c0.28,1.03,0.48,2.08,0.59,3.14c0.16,1.48,0.21,3.12,0.84,4.35c0.06,0.13,0.14,0.25,0.22,0.37 l7.81,0.4c0.02-0.01,0.04-0.01,0.06-0.02l0.31,0.03c0-0.06-0.01-0.11-0.01-0.17c0-0.03,0-0.07,0-0.1c0-0.02,0-0.04,0-0.06 c0-0.01,0-0.01,0-0.02c0-0.02,0-0.04,0-0.06c-0.02-0.33-0.04-0.65-0.06-0.98c0,0,0,0,0,0c-0.13-2.45-0.58-4.87-1.32-7.2 c-0.02-0.07-0.05-0.14-0.07-0.21c-0.35-1.01-0.79-1.99-1.31-2.92c-0.29-0.5-0.6-0.99-0.95-1.46c-0.89-1.21-1.99-2.24-3.25-3.05 c-2.59-1.73-5.79-2.31-8.82-1.61C186.9,105.01,186.82,105.03,186.73,105.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s61",
    d: "M186.73,105.15c3.66,0.92,6.88,3.12,9.05,6.21c0.48,0.66,0.84,1.39,1.06,2.18c0.19,0.81,0.16,1.66-0.09,2.46 c-0.22,0.77-0.53,1.55-0.57,2.34c-0.04,0.78,0.31,1.53,0.92,2.02c0.73,0.6,1.67,0.88,2.6,1.12c1.04,0.26,2.12,0.52,2.89,1.24 c0.09,0.09,0.25-0.08,0.15-0.17c-1.34-1.26-3.48-1.12-5.03-2.04c-0.72-0.43-1.29-1.1-1.32-2.01c-0.02-0.8,0.3-1.6,0.53-2.38 c0.26-0.78,0.32-1.61,0.18-2.41c-0.18-0.79-0.5-1.55-0.96-2.22c-0.99-1.51-2.25-2.83-3.72-3.89c-1.69-1.24-3.61-2.14-5.64-2.66 C186.66,104.91,186.61,105.12,186.73,105.15L186.73,105.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s61",
    d: "M195.16,110.33c1.09-1.03,1.36-2.61,0.64-3.69c-0.07-0.11-0.26,0.02-0.19,0.13c0.67,1.02,0.41,2.48-0.6,3.44 C194.9,110.3,195.05,110.43,195.16,110.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s61",
    d: "M196.91,115.61c-1.33,0.1-2.65-0.35-3.64-1.24c-0.09-0.09-0.25,0.08-0.15,0.17c1.03,0.93,2.4,1.39,3.79,1.29 C197.05,115.82,197.05,115.61,196.91,115.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s61",
    d: "M190.67,106.66c-0.33,0.46-0.85,0.75-1.42,0.79c-0.14,0.01-0.14,0.22,0,0.21c0.63-0.05,1.2-0.37,1.58-0.88 c0.04-0.04,0.04-0.11,0-0.15C190.78,106.61,190.71,106.62,190.67,106.66L190.67,106.66z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 84.82,
    className: "s62",
    width: 1.43,
    height: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "s62",
    d: "M199.71,85.3h-2.91v-0.48h2.91V85.3z M193.9,85.3h-2.91v-0.48h2.91V85.3z M188.08,85.3h-2.91v-0.48h2.91V85.3z  M182.27,85.3h-2.91v-0.48h2.91V85.3z M176.45,85.3h-2.91v-0.48h2.91V85.3z M170.64,85.3h-2.91v-0.48h2.91V85.3z M164.82,85.3 h-2.91v-0.48h2.91V85.3z M159.01,85.3h-2.91v-0.48h2.91L159.01,85.3z M153.19,85.3h-2.91v-0.48h2.91V85.3z M147.37,85.3h-2.91 v-0.48h2.91V85.3z M141.56,85.3h-2.91v-0.48h2.91V85.3z M135.74,85.3h-2.91v-0.48h2.91V85.3z M129.93,85.3h-2.91v-0.48h2.91V85.3z  M124.11,85.3h-2.91v-0.48h2.91V85.3z M118.3,85.3h-2.91v-0.48h2.91V85.3z M112.48,85.3h-2.91v-0.48h2.91V85.3z M106.66,85.3h-2.91 v-0.48h2.91V85.3z M100.85,85.3h-2.91v-0.48h2.91V85.3z M95.03,85.3h-2.91v-0.48h2.91V85.3z M89.22,85.3h-2.91v-0.48h2.91V85.3z  M83.4,85.3h-2.91v-0.48h2.91L83.4,85.3z M77.59,85.3h-2.91v-0.48h2.91L77.59,85.3z M71.77,85.3h-2.91v-0.48h2.91L71.77,85.3z  M65.96,85.3h-2.91v-0.48h2.91L65.96,85.3z M60.14,85.3h-2.91v-0.48h2.91V85.3z M54.32,85.3h-2.91v-0.48h2.91L54.32,85.3z  M48.51,85.3H45.6v-0.48h2.91L48.51,85.3z M42.69,85.3h-2.91v-0.48h2.91L42.69,85.3z M36.88,85.3h-2.91v-0.48h2.91L36.88,85.3z  M31.06,85.3h-2.91v-0.48h2.91V85.3z M25.25,85.3h-2.91v-0.48h2.91L25.25,85.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.62,
    y: 84.82,
    className: "s62",
    width: 1.43,
    height: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 81.48,
    className: "s62",
    width: 1.43,
    height: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "s62",
    d: "M199.71,81.96h-2.91v-0.48h2.91V81.96z M193.9,81.96h-2.91v-0.48h2.91V81.96z M188.08,81.96h-2.91v-0.48h2.91 V81.96z M182.27,81.96h-2.91v-0.48h2.91V81.96z M176.45,81.96h-2.91v-0.48h2.91V81.96z M170.64,81.96h-2.91v-0.48h2.91V81.96z  M164.82,81.96h-2.91v-0.48h2.91V81.96z M159.01,81.96h-2.91v-0.48h2.91L159.01,81.96z M153.19,81.96h-2.91v-0.48h2.91V81.96z  M147.37,81.96h-2.91v-0.48h2.91V81.96z M141.56,81.96h-2.91v-0.48h2.91V81.96z M135.74,81.96h-2.91v-0.48h2.91V81.96z  M129.93,81.96h-2.91v-0.48h2.91V81.96z M124.11,81.96h-2.91v-0.48h2.91V81.96z M118.3,81.96h-2.91v-0.48h2.91V81.96z  M112.48,81.96h-2.91v-0.48h2.91V81.96z M106.66,81.96h-2.91v-0.48h2.91V81.96z M100.85,81.96h-2.91v-0.48h2.91V81.96z  M95.03,81.96h-2.91v-0.48h2.91V81.96z M89.22,81.96h-2.91v-0.48h2.91V81.96z M83.4,81.96h-2.91v-0.48h2.91L83.4,81.96z  M77.59,81.96h-2.91v-0.48h2.91L77.59,81.96z M71.77,81.96h-2.91v-0.48h2.91L71.77,81.96z M65.96,81.96h-2.91v-0.48h2.91 L65.96,81.96z M60.14,81.96h-2.91v-0.48h2.91V81.96z M54.32,81.96h-2.91v-0.48h2.91L54.32,81.96z M48.51,81.96H45.6v-0.48h2.91 L48.51,81.96z M42.69,81.96h-2.91v-0.48h2.91L42.69,81.96z M36.88,81.96h-2.91v-0.48h2.91L36.88,81.96z M31.06,81.96h-2.91v-0.48 h2.91V81.96z M25.25,81.96h-2.91v-0.48h2.91L25.25,81.96z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.62,
    y: 81.48,
    className: "s62",
    width: 1.43,
    height: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 74.56,
    className: "s62",
    width: 1.43,
    height: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "s62",
    d: "M199.71,75.04h-2.91v-0.48h2.91V75.04z M193.9,75.04h-2.91v-0.48h2.91V75.04z M188.08,75.04h-2.91v-0.48h2.91 V75.04z M182.27,75.04h-2.91v-0.48h2.91V75.04z M176.45,75.04h-2.91v-0.48h2.91V75.04z M170.64,75.04h-2.91v-0.48h2.91V75.04z  M164.82,75.04h-2.91v-0.48h2.91V75.04z M159.01,75.04h-2.91v-0.48h2.91L159.01,75.04z M153.19,75.04h-2.91v-0.48h2.91V75.04z  M147.37,75.04h-2.91v-0.48h2.91V75.04z M141.56,75.04h-2.91v-0.48h2.91V75.04z M135.74,75.04h-2.91v-0.48h2.91V75.04z  M129.93,75.04h-2.91v-0.48h2.91V75.04z M124.11,75.04h-2.91v-0.48h2.91V75.04z M118.3,75.04h-2.91v-0.48h2.91V75.04z  M112.48,75.04h-2.91v-0.48h2.91V75.04z M106.66,75.04h-2.91v-0.48h2.91V75.04z M100.85,75.04h-2.91v-0.48h2.91V75.04z  M95.03,75.04h-2.91v-0.48h2.91V75.04z M89.22,75.04h-2.91v-0.48h2.91V75.04z M83.4,75.04h-2.91v-0.48h2.91L83.4,75.04z  M77.59,75.04h-2.91v-0.48h2.91L77.59,75.04z M71.77,75.04h-2.91v-0.48h2.91L71.77,75.04z M65.96,75.04h-2.91v-0.48h2.91 L65.96,75.04z M60.14,75.04h-2.91v-0.48h2.91V75.04z M54.32,75.04h-2.91v-0.48h2.91L54.32,75.04z M48.51,75.04H45.6v-0.48h2.91 L48.51,75.04z M42.69,75.04h-2.91v-0.48h2.91L42.69,75.04z M36.88,75.04h-2.91v-0.48h2.91L36.88,75.04z M31.06,75.04h-2.91v-0.48 h2.91V75.04z M25.25,75.04h-2.91v-0.48h2.91L25.25,75.04z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.62,
    y: 74.56,
    className: "s62",
    width: 1.43,
    height: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 69.78,
    className: "s62",
    width: 1.43,
    height: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "s62",
    d: "M199.71,70.26h-2.91v-0.48h2.91V70.26z M193.9,70.26h-2.91v-0.48h2.91V70.26z M188.08,70.26h-2.91v-0.48h2.91 V70.26z M182.27,70.26h-2.91v-0.48h2.91V70.26z M176.45,70.26h-2.91v-0.48h2.91V70.26z M170.64,70.26h-2.91v-0.48h2.91V70.26z  M164.82,70.26h-2.91v-0.48h2.91V70.26z M159.01,70.26h-2.91v-0.48h2.91L159.01,70.26z M153.19,70.26h-2.91v-0.48h2.91V70.26z  M147.37,70.26h-2.91v-0.48h2.91V70.26z M141.56,70.26h-2.91v-0.48h2.91V70.26z M135.74,70.26h-2.91v-0.48h2.91V70.26z  M129.93,70.26h-2.91v-0.48h2.91V70.26z M124.11,70.26h-2.91v-0.48h2.91V70.26z M118.3,70.26h-2.91v-0.48h2.91V70.26z  M112.48,70.26h-2.91v-0.48h2.91V70.26z M106.66,70.26h-2.91v-0.48h2.91V70.26z M100.85,70.26h-2.91v-0.48h2.91V70.26z  M95.03,70.26h-2.91v-0.48h2.91V70.26z M89.22,70.26h-2.91v-0.48h2.91V70.26z M83.4,70.26h-2.91v-0.48h2.91L83.4,70.26z  M77.59,70.26h-2.91v-0.48h2.91L77.59,70.26z M71.77,70.26h-2.91v-0.48h2.91L71.77,70.26z M65.96,70.26h-2.91v-0.48h2.91 L65.96,70.26z M60.14,70.26h-2.91v-0.48h2.91V70.26z M54.32,70.26h-2.91v-0.48h2.91L54.32,70.26z M48.51,70.26H45.6v-0.48h2.91 L48.51,70.26z M42.69,70.26h-2.91v-0.48h2.91L42.69,70.26z M36.88,70.26h-2.91v-0.48h2.91L36.88,70.26z M31.06,70.26h-2.91v-0.48 h2.91V70.26z M25.25,70.26h-2.91v-0.48h2.91L25.25,70.26z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.62,
    y: 69.78,
    className: "s62",
    width: 1.43,
    height: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 59.52,
    className: "s62",
    width: 1.43,
    height: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "s62",
    d: "M199.71,60h-2.91v-0.48h2.91V60z M193.9,60h-2.91v-0.48h2.91V60z M188.08,60h-2.91v-0.48h2.91V60z M182.27,60 h-2.91v-0.48h2.91V60z M176.45,60h-2.91v-0.48h2.91V60z M170.64,60h-2.91v-0.48h2.91V60z M164.82,60h-2.91v-0.48h2.91V60z  M159.01,60h-2.91v-0.48h2.91L159.01,60z M153.19,60h-2.91v-0.48h2.91V60z M147.37,60h-2.91v-0.48h2.91V60z M141.56,60h-2.91v-0.48 h2.91V60z M135.74,60h-2.91v-0.48h2.91V60z M129.93,60h-2.91v-0.48h2.91V60z M124.11,60h-2.91v-0.48h2.91V60z M118.3,60h-2.91 v-0.48h2.91V60z M112.48,60h-2.91v-0.48h2.91V60z M106.66,60h-2.91v-0.48h2.91V60z M100.85,60h-2.91v-0.48h2.91V60z M95.03,60 h-2.91v-0.48h2.91V60z M89.22,60h-2.91v-0.48h2.91V60z M83.4,60h-2.91v-0.48h2.91L83.4,60z M77.59,60h-2.91v-0.48h2.91L77.59,60z  M71.77,60h-2.91v-0.48h2.91L71.77,60z M65.96,60h-2.91v-0.48h2.91L65.96,60z M60.14,60h-2.91v-0.48h2.91V60z M54.32,60h-2.91 v-0.48h2.91L54.32,60z M48.51,60H45.6v-0.48h2.91L48.51,60z M42.69,60h-2.91v-0.48h2.91L42.69,60z M36.88,60h-2.91v-0.48h2.91 L36.88,60z M31.06,60h-2.91v-0.48h2.91V60z M25.25,60h-2.91v-0.48h2.91L25.25,60z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.62,
    y: 59.52,
    className: "s62",
    width: 1.43,
    height: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "s60",
    d: "M87.36,45.72c0,7.18-5.82,13-13,13c-7.18,0-13-5.82-13-13c0-7.18,5.82-13,13-13l0,0 c7.15-0.03,12.96,5.74,13,12.88C87.36,45.64,87.36,45.68,87.36,45.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s63",
    d: "M79.68,42.61L79.68,42.61l-0.06,0.12c0.57-1.41,0.05-3.15-0.97-4.21c-1.02-1.06-2.44-1.55-3.84-1.74 c-1.04-0.18-2.1-0.1-3.1,0.24c-1.43,0.55-2.52,1.82-3.43,3.15c-0.42,0.61-0.83,1.3-0.79,2.05c0.04,0.7,0.46,1.3,0.8,1.9 c0.34,0.6,0.63,1.34,0.38,1.99c-0.15,0.39-0.46,0.67-0.71,0.98c-0.25,0.32-0.46,0.75-0.34,1.14c0.11,0.31,0.37,0.54,0.7,0.6 c0.31,0.05,0.62,0.04,0.92-0.02l7.97-1.2c1.85-0.28,3.13-2.01,2.85-3.86C80,43.35,79.87,42.96,79.68,42.61z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s64",
    cx: 73.75,
    cy: 43.66,
    r: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "s65",
    d: "M84.12,54.3c-4.68,5.33-12.78,5.92-18.18,1.31l1.11-3.11c0.51-1.13,1.61-1.88,2.84-1.95l0.71-0.04l1.69-1.46 c0,0,4.56-0.16,4.49-0.24l2.76,1.66l0-0.01l1.08,0.07c1.24,0.07,2.33,0.83,2.84,1.95L84.12,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s63",
    d: "M77.45,40.05c-0.1-0.53-0.64-0.78-1.11-0.89c-1.35-0.34-2.75-0.42-4.13-0.23c-1,0.14-2.03,0.46-2.76,1.24 c-0.59,0.66-0.92,1.51-0.94,2.39c-0.03,0.53,0.09,1.05,0.34,1.52c0.23,0.44,0.67,0.73,1.17,0.75L70.07,45 c2.04-0.33,3.84-1.53,4.92-3.29c-0.21,0.77-0.64,1.46-1.23,1.99c1.32-0.53,2.47-1.41,3.32-2.55C77.3,40.83,77.52,40.45,77.45,40.05 z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s60",
    cx: 185.11,
    cy: 49.84,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s63",
    cx: 181.54,
    cy: 43.13,
    r: 1.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s63",
    cx: 184.48,
    cy: 47.29,
    r: 4.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s66",
    cx: 184.86,
    cy: 48.16,
    r: 3.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "s63",
    d: "M187.43,44.31c-2.04-1.24-4.7-0.6-5.95,1.44c-0.43,0.7-0.65,1.51-0.63,2.33c1.92,0.48,3.95,0.85,6,0.12 l0.48-1.19l0.29,1.19c0.63,0.26,1.25,0.47,1.88,0C189.55,46.63,188.76,45.14,187.43,44.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s63",
    d: "M179.83,38.15c-1.31-0.56-2.83-0.33-3.92,0.6c-1.06,0.95-1.56,2.37-1.35,3.78c0.21,1.41,1.06,2.62,1.85,3.81 c0.79,1.19,1.56,2.48,1.56,3.91c0,2.14-1.73,3.87-3.87,3.87c1.2,0.52,2.46,1.05,3.77,0.99s2.68-0.9,2.89-2.2 c0.15-0.93-0.3-1.84-0.68-2.7c-0.62-1.41-1.07-2.89-1.34-4.4c-0.13-0.72-0.21-1.48,0.03-2.18c0.39-1.06,1.42-1.74,2.54-1.68 l0.43-0.39C181.9,40.13,181.13,38.76,179.83,38.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s65",
    d: "M194.89,58.54c-4.68,5.33-12.78,5.92-18.18,1.31l1.11-3.11c0.51-1.13,1.61-1.88,2.84-1.95l0.71-0.04l1.69-1.46 c0,0,4.56-0.16,4.49-0.24l2.76,1.66l0-0.01l1.08,0.07c1.24,0.07,2.33,0.83,2.84,1.95L194.89,58.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s60",
    d: "M161.13,36.01c-0.01,7.18-5.84,12.99-13.02,12.97c-7.18-0.01-12.99-5.84-12.97-13.02 c0.01-7.18,5.84-12.99,13.02-12.97c7.16-0.01,12.97,5.79,12.97,12.95C161.13,35.97,161.13,35.99,161.13,36.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s63",
    d: "M142.11,31.76c0.54-1.71,1.76-3.28,3.45-3.86c1.69-0.58,4.16,0.3,5.44,1.57c2.32,2.32,2.89,10.27,1.29,12.79 c-0.32-0.02-1.41-0.03-1.73-0.04l-0.45-1.52v1.5c-0.51-0.02-1.03-0.03-1.55-0.03c-3.62-0.04-6.56-2.95-6.65-6.57 C141.86,33.93,141.9,32.44,142.11,31.76z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s66",
    cx: 147.94,
    cy: 33.73,
    r: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "s63",
    d: "M144.75,30.48l4.26-2.14l0,0c1.78,0.8,2.98,2.5,3.14,4.44l0.11,1.27l-1.79-0.45l-0.2-1.63l-0.3,1.5l-0.82-0.21 l0.01-2.53l-0.82,2.53l-2.94-0.68L144.75,30.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s65",
    d: "M157.78,44.59c-4.68,5.33-12.78,5.92-18.18,1.31l1.11-3.11c0.51-1.13,1.61-1.88,2.84-1.95l0.71-0.04l1.69-1.46 c0,0,4.56-0.16,4.49-0.24l2.76,1.66l0-0.01l1.08,0.07c1.24,0.07,2.33,0.83,2.84,1.95L157.78,44.59z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s60",
    cx: 112.41,
    cy: 57,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s67",
    cx: 112.05,
    cy: 54.46,
    r: 4.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "s65",
    d: "M122.16,65.7c-4.68,5.33-12.78,5.92-18.18,1.31l1.11-3.11c0.51-1.13,1.61-1.88,2.84-1.95l0.71-0.04l1.69-1.46 c0,0,4.56-0.16,4.49-0.24l2.76,1.66l0-0.01l1.08,0.07c1.24,0.07,2.33,0.83,2.84,1.95L122.16,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s63",
    d: "M116.42,51.89c-0.35-1.25-1.15-2.34-2.24-3.05c-0.87-0.56-1.96-0.84-2.94-0.55s-1.8,1.26-1.74,2.31 c-0.37-0.1-0.77,0.02-1.02,0.32c-0.25,0.29-0.42,0.64-0.5,1.01c-0.32,1.17-0.3,2.41,0.06,3.57l-0.02,0.17 c0.48-0.08,0.85-0.49,1.07-0.93s0.36-0.93,0.6-1.36c0.25-0.43,0.65-0.81,1.14-0.83l-0.04,0.75c0.42-0.22,0.84-0.43,1.26-0.65 c-0.1,0.24-0.2,0.48-0.3,0.72c0.37-0.15,0.73-0.31,1.1-0.46c-0.04,0.23-0.08,0.46-0.12,0.69c0.39-0.81,1.37-1.15,2.18-0.76 c0.02,0.01,0.05,0.02,0.07,0.03c0.44,0.29,0.75,0.74,0.89,1.25c0.13,0.51,0.2,1.03,0.21,1.56 C116.65,54.5,116.77,53.16,116.42,51.89z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s60",
    cx: 37.17,
    cy: 62.91,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    id: "a04f79c1-b358-4543-9edb-632b127caa90",
    className: "s66",
    cx: 36.88,
    cy: 60.32,
    r: 3.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "s65",
    d: "M46.75,71.49c-4.68,5.33-12.78,5.92-18.18,1.31l1.11-3.11c0.51-1.13,1.61-1.88,2.84-1.95l0.71-0.04l1.69-1.46 c0,0,4.56-0.16,4.49-0.24l2.76,1.66l0-0.01l1.08,0.07c1.24,0.07,2.33,0.83,2.84,1.95L46.75,71.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s63",
    d: "M33.3,62.14c-0.01-0.02-0.01-0.04-0.02-0.06c-0.02,0.01-0.03,0.03-0.05,0.04L33.3,62.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s63",
    d: "M41.61,58.91c-0.04-0.81-0.43-1.56-1.06-2.07c-0.25-0.16-0.47-0.35-0.65-0.59c-0.09-0.18-0.16-0.36-0.22-0.55 c-0.3-0.72-1.17-1.1-1.94-0.99c-0.78,0.15-1.46,0.61-1.89,1.27c-0.64-0.31-1.41-0.04-1.72,0.61c-0.13,0.28-0.16,0.59-0.08,0.89 c-0.4-0.32-1.05-0.06-1.3,0.39s-0.21,1-0.14,1.51c0.13,0.92,0.36,1.82,0.67,2.7c0.39-0.34,0.37-0.97,0.32-1.5 c-0.05-0.55-0.02-1.22,0.46-1.49c0.46-0.26,1.03,0.03,1.54,0.17c0.82,0.23,1.7,0.09,2.41-0.38c0.25-0.2,0.52-0.38,0.79-0.55 c0.28-0.17,0.63-0.17,0.92-0.02c0.22,0.19,0.38,0.46,0.43,0.75c0.2,0.67,0.39,1.34,0.59,2C41.32,60.51,41.64,59.72,41.61,58.91z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.97,
    y: 85.91,
    className: "s68",
    width: 1.24,
    height: 36.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.11,
    y: 68.93,
    className: "s68",
    width: 1.24,
    height: 53.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.33,
    y: 80.09,
    className: "s68",
    width: 1.24,
    height: 42.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.55,
    y: 59.62,
    className: "s68",
    width: 1.24,
    height: 62.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.76,
    y: 73.89,
    className: "s68",
    width: 1.24,
    height: 48.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s65",
    cx: 73.81,
    cy: 69.78,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s65",
    cx: 148.24,
    cy: 59.86,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s65",
    cx: 111.03,
    cy: 80.33,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s65",
    cx: 36.59,
    cy: 85.91,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s65",
    cx: 185.46,
    cy: 73.5,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "s68",
    d: "M212.08,121.9H10.61l-1.27,0.63c0,0.35,0.28,0.63,0.63,0.63h202.11c0.35,0,0.63-0.28,0.63-0.63 S212.43,121.9,212.08,121.9L212.08,121.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s68",
    cx: 9.86,
    cy: 122.23,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s62",
    cx: 36.6,
    cy: 133.21,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s62",
    cx: 73.85,
    cy: 133.21,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s62",
    cx: 111.09,
    cy: 133.21,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s62",
    cx: 148.1,
    cy: 133.21,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s62",
    cx: 185.34,
    cy: 133.21,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s68",
    cx: 213.27,
    cy: 122.23,
    r: 3.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSlide6);
export default __webpack_public_path__ + "static/media/home-slide-6.a79add620f9012cf32da989066ca7453.svg";
export { ForwardRef as ReactComponent };